module.exports = __webpack_public_path__ + "static/media/user-management.fee44a48.svg";